import { useState, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { heroSlides } from '@/mocks/videos';

export default function HeroSection() {
  const [current, setCurrent] = useState(0);

  const next = useCallback(() => {
    setCurrent((prev) => (prev + 1) % heroSlides.length);
  }, []);

  const prev = useCallback(() => {
    setCurrent((prev) => (prev - 1 + heroSlides.length) % heroSlides.length);
  }, []);

  useEffect(() => {
    const timer = setInterval(next, 6000);
    return () => clearInterval(timer);
  }, [next]);

  const slide = heroSlides[current];

  return (
    <section className="relative w-full h-[420px] md:h-[600px] overflow-hidden">
      {heroSlides.map((s, i) => (
        <div
          key={s.id}
          className={`absolute inset-0 transition-opacity duration-700 ${
            i === current ? 'opacity-100' : 'opacity-0 pointer-events-none'
          }`}
        >
          <img
            src={s.bgImage}
            alt={s.title}
            className="w-full h-full object-cover object-top"
          />
        </div>
      ))}

      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/20 to-black/60"></div>

      <div className="absolute inset-0 flex items-center">
        <div className="w-full px-4 md:px-6">
          <div className="max-w-[1200px] mx-auto">
            <div className="max-w-xl">
              <span className="inline-block px-3 py-1 text-xs font-medium bg-accent-500 text-background-50 rounded-full mb-4">
                {slide.tag}
              </span>
              <h1 className="text-3xl md:text-5xl font-heading font-bold text-background-50 mb-3 leading-tight">
                {slide.title}
              </h1>
              <p className="text-sm md:text-base text-background-50/70 mb-2">{slide.subtitle}</p>
              <p className="text-xs md:text-sm text-background-50/50 mb-6 line-clamp-2">{slide.description}</p>
              <div className="flex items-center gap-3">
                <Link
                  to={slide.link}
                  className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 text-background-50 rounded-full 
                    text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                >
                  <i className="ri-play-fill text-lg"></i>
                  立即观看
                </Link>
                <div className="flex items-center gap-1.5 text-background-50/70">
                  <i className="ri-star-fill text-accent-500 text-sm"></i>
                  <span className="text-sm font-medium text-background-50">{slide.rating}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <button
        onClick={prev}
        className="absolute left-3 md:left-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center 
          rounded-full bg-background-50/20 hover:bg-background-50/40 backdrop-blur-sm text-background-50 transition-all cursor-pointer"
        aria-label="上一张"
      >
        <i className="ri-arrow-left-s-line text-xl"></i>
      </button>

      <button
        onClick={next}
        className="absolute right-3 md:right-6 top-1/2 -translate-y-1/2 w-10 h-10 flex items-center justify-center 
          rounded-full bg-background-50/20 hover:bg-background-50/40 backdrop-blur-sm text-background-50 transition-all cursor-pointer"
        aria-label="下一张"
      >
        <i className="ri-arrow-right-s-line text-xl"></i>
      </button>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
        {heroSlides.map((_, i) => (
          <button
            key={i}
            onClick={() => setCurrent(i)}
            className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
              i === current ? 'bg-primary-500 w-6' : 'bg-background-50/40 hover:bg-background-50/60'
            }`}
            aria-label={`第${i + 1}张`}
          />
        ))}
      </div>
    </section>
  );
}